<script>
import ViewHeader from '@/components/ViewHeader.vue';
import { useMetersStore } from '@/stores/meters.ts';
import SatelliteApi from '@/data/SatelliteApi.ts';
import { useCredentialsStore } from '@/stores/credentials.js';

export default {
  name: 'SelectMeterView',
  components: { ViewHeader },
  emits: [],
  mixins: [],
  props: {},
  data() {
    return {
      meterStore: useMetersStore(),
      callOngoing: false,
      error: null,
    };
  },
  mounted() {
    const meters = useMetersStore().getMeters;
    const postalCode = useCredentialsStore().credentials.postal_code;
    const plantCode = useCredentialsStore().credentials.plant_code;

    if (meters.length === 0) {
      this.error = 'Geen meters gevonden!';
    } else if (meters.length === 1) {
      this.callOngoing = true;
      new SatelliteApi() //
        .getMeterDetails(postalCode, plantCode, meters[0].id)
        .then((rsp) => {
          if (rsp.data.message) {
            this.error = rsp.data.message;
            return;
          }

          this.meterStore.setSelected(meters[0]);
          this.meterStore.setMeterDetails(rsp.data);
          this.$router.push({ name: 'home' });
        })
        .catch(() => (this.error = 'Meters ophalen niet gelukt!'))
        .finally(() => (this.callOngoing = false));
    }
  },
  computed: {},
  methods: {
    logOut() {
      useCredentialsStore().clear();
      this.meterStore.clearAll();

      this.$router.push({ name: 'sign-in' });
    },
  },
};
</script>

<template>
  <ProgressSpinner v-if="callOngoing" style="height: 3rem; margin-top: 40vh;"/>
  <div v-else-if="error" class="p-4">
    <div class="text-lg font-semibold mb-2"> Er is iets misgegaan </div>
    <Message severity="error"> {{ error }} </Message>
    <Button @click="logOut()" label="Uitloggen" class="mt-4"/>
  </div>
</template>

<style scoped></style>
